<template>
  <FormSection title="Account">
    <template #text>
      Ändere die Grundeinstellungen Deines Accounts.
    </template>
    <template #form>
      <AccountForm :resource="data" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <SubmitButton @click="onSubmit" :load="updating">
      Speichern
    </SubmitButton>
  </FormButtons>
</template>

<script setup>
import { ref, toRef } from 'vue';
import { useUpdateResource } from '@/client/actions';
import { useStore } from 'vuex';

const store = useStore();
const data = ref(store.getters['auth/user']);
const errors = ref({});
const message = ref('');
const updating = ref(false);

const onSuccess = (result) =>
{
  updating.value = false;
  data.value = {...store.getters['auth/user']};
  errors.value = {};
  message.value = '';
};

const onFailure = (error) =>
{
  updating.value = false;
  message.value = error.message;
  errors.value = error.errors;
};

const onSubmit = () =>
{
  updating.value = true;
  store.dispatch('auth/update', data.value)
  .then(result => onSuccess(result))
  .catch(error => onFailure(error));
};
</script>
